import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { smartyStreetService } from "../../utilities/smartyStreetService";
export const smartyStreetApi = createAsyncThunk(
  "users/smartyStreetApi",
  smartyStreetService
);
const initialState = {
  smartyStreetData: {
    loader:false,
    responseDetails:{
      callback: () =>{return false},
      has_i: false,
      i: 0,
      providedAddress: {
        street: "",
        street2: "",
        city: "",
        zipcode: "",
        state: "",
        record_type : "",
        isValidateAddress : '',
        IsValid : false,
        NoMatch : false,
        PartialMatch : true,
        ExactMatch : false
      },
      suggestedAddress: {
        street: "",
        street2: "",
        city: "",
        zipcode: "",
        state: "",
        record_type : "",
        isValidateAddress : '',
        IsValid : true,
        NoMatch : false,
        PartialMatch : false,
        ExactMatch : false,
        SecInfoNotMatch : false,
      },
      response:{
        street: "",
        street2: "",
        city: "",
        zipcode: "",
        state: "",
        record_type : "",
        isValidateAddress : '',
        IsValid : true,
        NoMatch : false,
        PartialMatch : false,
        ExactMatch : false,
        SecInfoNotMatch : false,
      },
      ss_msg: '',
      partial: false,
      ss_toggle: false,
      record_type:'',
      allowSSRequest: true,
    },
   
  },
};
const smartyStreetSlice = createSlice({
  name: "registrations",
  initialState,
  reducers: {
    resetSmartySteert : (state,action)=>{
        state.smartyStreetData={
          loader:false,
          responseDetails:{
            callback: () =>{return false},
            has_i: false,
            i: 0,
            providedAddress: {
              street: "",
              street2: "",
              city: "",
              zipcode: "",
              state: "",
              record_type : "",
              isValidateAddress : '',
              IsValid : false,
              NoMatch : false,
              PartialMatch : true,
              ExactMatch : false
            },
            suggestedAddress: {
              street: "",
              street2: "",
              city: "",
              zipcode: "",
              state: "",
              record_type : "",
              isValidateAddress : '',
              IsValid : true,
              NoMatch : false,
              PartialMatch : false,
              ExactMatch : false,
              SecInfoNotMatch : false,
            },
            response:{
              street: "",
              street2: "",
              city: "",
              zipcode: "",
              state: "",
              record_type : "",
              isValidateAddress : '',
              IsValid : true,
              NoMatch : false,
              PartialMatch : false,
              ExactMatch : false,
              SecInfoNotMatch : false,
            },
            ss_msg: '',
            partial: false,
            ss_toggle: false,
            record_type:'',
            allowSSRequest: true,
          },
         
        }
    },
    resetregsuccess: (state,action) => {
      state.smartyStreetData.registrationsucces = false;
    },
    ss_toggle: (state ,action) => {
      state.smartyStreetData.responseDetails.ss_toggle=action.payload;
    },
    response: (state ,action) => {
      state.smartyStreetData.responseDetails.response=action.payload;
    },
    record_type: (state ,action) => {
      state.smartyStreetData.responseDetails.record_type=action.payload;
    },
    callBackMethod: (state ,action) => {
      state.smartyStreetData.responseDetails.callback=action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(smartyStreetApi.pending, (state, action) => {
        state.smartyStreetData.loader = true;
      })
      .addCase(smartyStreetApi.fulfilled, (state, action) => {
        // state.smartyStreetData.responseDetails.partial=action.payload.partial
        state.smartyStreetData.responseDetails=action.payload  
        state.smartyStreetData.loader = false;      
      })
      .addCase(smartyStreetApi.rejected, (state, action) => {
          let response ={}
          let address =action.meta.arg.address
          let name =action.meta.arg.name
                response.street =
                address.addressLine1 != undefined ? address.addressLine1 : "";
              response.street2 =
                address.addressLine2 != undefined ? address.addressLine2 : "";
              response.city = address.city != undefined ? address.city : "";
              response.state = address.state != undefined ? address.state : "";
              response.zipcode =
                address.zipCode != undefined ? address.zipCode : "";
              response.record_type = "";
              response.isValidateAddress = "NoMatch";
                        response.IsValid = false;
                        response.NoMatch = true;
                        response.PartialMatch = false;
                        response.ExactMatch = false;
                        response.SecInfoNotMatch = false;
              if (typeof i != "undefined") {
                action.meta.arg.callbackVerifiedAddress(response, action.meta.arg.name);
              } else {
                action.meta.arg.callbackVerifiedAddress(response,action.meta.arg.name);
              }
        state.smartyStreetData.loader = false;
      });
  },
});
export const {resetregsuccess,ss_toggle,response,record_type,callBackMethod,resetSmartySteert} = smartyStreetSlice.actions;
export default smartyStreetSlice.reducer;
